import { HealthConnectionTypes } from '@routes/dashboard/settings/consents/health-data/health-data.types';

import { NotificationSettings } from './notification';
import { WearableScopes } from './wearables-types';

type ProfilePictureData = {
  fileName: string;
  filePath: string;
  fileSize: number;
  image: string;
  isAvatar: boolean;
};

export type Patient = {
  id: number;
  firstname?: string;
  lastname?: string;
  birthdate?: string;
  profilePicture?: string;
  profilePictureData?: ProfilePictureData;
  deviceToken?: string;
  deviceIdentifier?: string;
  assetAPIKey?: string;
  assetFolderId?: number;
  gender?: string;
  email?: string;
  mobileNumber?: string;
  address?: string;
  postalCode?: string;
  city?: string;
  country?: string;
  insuranceType?: string;
  insuranceCompany?: string;
  insuranceNumber?: string;
  isLoggedIn: boolean;
  isSessionExpired: boolean;
  isPinMechanismActive: boolean;
  is2faActive?: boolean;
  primarySourceId?: string;
  primarySourceUuid?: string;
  uuid?: string;
  userId?: number;
  sessionId?: string;
  isAccountCreated: boolean;
  isAccountVerified: boolean;
  pinLockAttempts: number;
  isConsentForTracking?: boolean;
  isBirthdayHardcoded: boolean;
  securityPIN?: string;
  healthDataInfo?: HealthConnectionTypes;
  withingsScopes?: WearableScopes;
  sessionLastActive?: number;
  hasNewNotification: boolean;
  accessToken?: string;
  notificationSettings: NotificationSettings;
};

export enum PatientConnectionStatus {
  Online = 'online',
  Away = 'away',
  Offline = 'offline',
  Unpaired = 'unpaired',
}

export type PatientPayload = Omit<
  Patient,
  | 'id'
  | 'isLoggedIn'
  | 'isSessionExpired'
  | 'isPinMechanismActive'
  | 'isBiometricsOn'
  | 'isAccountCreated'
  | 'isAccountVerified'
  | 'pinLockAttempts'
  | 'isBirthdayHardcoded'
  | 'hasNewNotification'
  | 'notificationSettings'
>;
